var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-view" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-form",
            {
              ref: "nodeForm",
              staticClass: "node-form",
              attrs: {
                "label-width": "150px",
                model: _vm.nodeForm,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Node Name") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("Node Name"),
                      disabled: _vm.isView
                    },
                    model: {
                      value: _vm.nodeForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.nodeForm, "name", $$v)
                      },
                      expression: "nodeForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Node IP"), prop: "ip", required: "" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Node IP"), disabled: "" },
                    model: {
                      value: _vm.nodeForm.ip,
                      callback: function($$v) {
                        _vm.$set(_vm.nodeForm, "ip", $$v)
                      },
                      expression: "nodeForm.ip"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Node MAC"), prop: "ip", required: "" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Node MAC"), disabled: "" },
                    model: {
                      value: _vm.nodeForm.mac,
                      callback: function($$v) {
                        _vm.$set(_vm.nodeForm, "mac", $$v)
                      },
                      expression: "nodeForm.mac"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Description") } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("Description"),
                      disabled: _vm.isView
                    },
                    model: {
                      value: _vm.nodeForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.nodeForm, "description", $$v)
                      },
                      expression: "nodeForm.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.isView
        ? _c(
            "el-row",
            { staticClass: "button-container" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "success" },
                  on: { click: _vm.onSave }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }